import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const ButtonStyled = styled.button<T>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  min-height: 30px;
  background: rgba(107, 107, 107, 0.01);
  border: 1px solid #ffffff;
  border-radius: 4px;
  color: white;

  & > i {
    margin-right: 0.2em;
  }

  &:hover {
    opacity: 0.7;
  }
`;
